// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__juxCC","active":"Navbar_active__7zyOp","link":"Navbar_link__Jw1Xb","shadowed2":"Navbar_shadowed2__hIHfo"};